import script from "./Robot.vue?vue&type=script&setup=true&lang=js"
export * from "./Robot.vue?vue&type=script&setup=true&lang=js"

import "./Robot.vue?vue&type=style&index=0&id=3fb8d16e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb8d16e"]])

export default __exports__